import React from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import "./about.css";

export default function AboutUs() {
  return (
    <div className="about-page">
      <Helmet>
        <title>About Us | 164 Diecast Zone</title>
        <meta
          name="description"
          content="Learn about 164 Diecast Zone — India's destination for premium 1:64 scale diecast model cars, chase editions, and collector exclusives."
        />
        <link rel="canonical" href="https://164diecastzone.com/about-us" />
        <meta property="og:title" content="About Us | 164 Diecast Zone" />
        <meta
          property="og:description"
          content="Learn about 164 Diecast Zone — India's destination for premium 1:64 scale diecast model cars, chase editions, and collector exclusives."
        />
        <meta property="og:url" content="https://164diecastzone.com/about-us" />
      </Helmet>

      {/* Hero */}
      <section className="about-hero">
        <div className="about-hero-inner">
          <span className="about-eyebrow">About 164diecastzone</span>
          <h1>Built for Collectors</h1>
          <p>
            A trusted home for diecast enthusiasts across India.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="about-content">
        <div className="about-container">

          <p>
            We're a Bangalore-based <strong>164diecastzone</strong> dedicated to
            delivering the best value in diecast models.
          </p>

          <div className="about-stats">
            <div>
              <h3>5,000+</h3>
              <span>Orders shipped</span>
            </div>
            <div>
              <h3>300+</h3>
              <span>Happy customers</span>
            </div>
            <div>
              <h3>2023</h3>
              <span>Founded</span>
            </div>
          </div>

          <p>
            Since launching in <strong>March 2023</strong>, we've shipped over
            <strong> 5,000 orders</strong> and earned the loyalty of
            <strong> 300+ happy customers</strong> across India.
          </p>

          <p>
            Our brand stands for <strong>value</strong>, <strong>variety</strong>,
            and <strong>service</strong>.
          </p>

          <div className="about-highlight">
            At <strong>164diecastzone</strong>, our young, passionate team of
            diecast lovers and car enthusiasts truly gets what collectors crave.
            We work tirelessly to simplify your hobby, eliminating the hunt for
            that perfect piece.
          </div>

          <p>
            With our diverse product range, tailored catalogs, and flawless
            packaging, we make building your collection effortless —
            <strong> just a click away.</strong>
          </p>

        </div>
      </section>

    </div>
  );
}
